<template>
  <div style="background: #ffffff">
    <div
      v-if="!hidenBrea"
      class="xuanfu animate__animated animate__fadeInBottomRight"
    >
      <div class="bear">
        <img
          :src="bear"
          alt=""
          @mouseover="bear = require('../../assets/index/bearMove.gif')"
          @mouseleave="bear = require('../../assets/index/bear.png')"
        />
      </div>
      <div
        class="phone"
        @mouseleave="
          (showEwm = false),
            (showNumber = false),
            (bear = require('../../assets/index/bear.png'))
        "
      >
        <div
          class="mobile"
          @mouseover="
            (showNumber = true),
              (showEwm = false),
              (bear = require('../../assets/index/bearMove.gif'))
          "
        >
          <img
            :src="
              showNumber
                ? require('../../assets/index/phoneActive.png')
                : require('../../assets/index/phone.png')
            "
            alt=""
          />
          <img
            v-if="showNumber"
            class="phoneNumber"
            src="../../assets/index/phoneNumber.png"
            alt=""
          />
        </div>
        <div
          class="wechat"
          @mouseover="
            (showEwm = true),
              (showNumber = false),
              (bear = require('../../assets/index/bearMove.gif'))
          "
        >
          <img
            :src="
              showEwm
                ? require('../../assets/index/wechatActive.png')
                : require('../../assets/index/wechat.png')
            "
            alt=""
          />
          <img
            v-if="showEwm"
            class="ewm"
            src="../../assets/index/ewm.png"
            alt=""
          />
        </div>
        <div
          class="up"
          @click="goTop"
          @mouseover="
            (showEwm = false),
              (showNumber = false),
              (bear = require('../../assets/index/bear.png'))
          "
        >
          <img src="../../assets/index/up.png" alt="" />
        </div>
      </div>
      <!-- <div class="shouqi">
        <img src="../../assets/index/phone.png" alt="" />
      </div> -->
    </div>

    <full-page :options="options" id="fullpage" ref="fullpage">
      <div class="section fp-auto-height">
        <Header :index="0" @handleFunc="sydk"></Header>
        <Home :index="index"></Home>
      </div>
      <div class="section">
        <Part2 :index="index" />
      </div>
      <div class="section">
        <Part3 :index="index"></Part3>
      </div>
      <div class="section">
        <Part4 :index="index"></Part4>
      </div>
      <div class="section contact_footer">
        <Part5 style="position: absolute; bottom: 0" :index="index"></Part5>
      </div>
    </full-page>
  </div>
</template>

<script>
import Part2 from "../../components/Part2";
import Part3 from "../../components/Part3";
import Part4 from "../../components/Part4";
import Part5 from "../../components/Part5";
import Header from "../../components/Header";
import Home from "../../components/Home";
export default {
  name: "index",
  label: process.env.LABEL,
  style: process.env.STYLE,
  components: { Header, Home, Part2, Part3, Part4, Part5 },
  data() {
    return {
      hidenBrea: false,
      showNumber: false,
      showEwm: false,
      bear: require("../../assets/index/bear.png"),
      show: true,
      index: 0,
      options: {
        menu: "menu",
        licenseKey: "OPEN-SOURCE-GPLV3-LICENSE",
        afterLoad: this.afterLoad,
        navigation: true,
        sectionsColor: ["#ffffff", "#ffffff", "#ecedef", "#ffffff", "#ffffff"],
        scrollingSpeed: 500,
        scrollOverflow: true,
      },
    };
  },
  mounted() {
    if (sessionStorage.getItem("show")) {
      this.show = JSON.parse(sessionStorage.getItem("show"));
    } else {
      this.show = true;
    }
    // console.log(this.$refs.fullpage, this.show);
    this.$root.fullpage = this.$refs.fullpage;
  },
  methods: {
    sydk(val) {
      // console.log(val);
      if (val == "true") {
        this.hidenBrea = true;
      } else {
        this.hidenBrea = false;
      }
    },
    goTop() {
      this.$root.fullpage.api.moveTo(1, 0);
      cancelAnimationFrame(this.timer);
      const self = this;
      self.timer = requestAnimationFrame(function fn() {
        const oTop =
          document.body.scrollTop || document.documentElement.scrollTop;
        if (oTop > 0) {
          document.body.scrollTop = document.documentElement.scrollTop =
            oTop - 50;
          self.timer = requestAnimationFrame(fn);
        } else {
          cancelAnimationFrame(self.timer);
        }
      });
    },
    dialog(index) {
      switch (index) {
        case 1:
      }
    },
    leave() {
      window.open("about:blank", "_self").close();
      window.close();
    },
    enter() {
      this.show = false;
      sessionStorage.setItem("show", false);
    },
    afterLoad: function (origin, destination) {
      this.$root.destination = destination.index;
      this.index = destination.index;
      // console.log(this.$root.destination);
    },
  },
};
</script>

<style lang="less" scoped>
#menu {
  position: fixed;
  right: unset !important;
  top: 0 !important;
  width: 100%;
}
.contact_footer {
  height: 350px !important;
}
.xuanfu {
  position: fixed;
  right: 0;
  z-index: 1;
  top: 179px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  .bear {
    width: 263px !important;
    height: 457px !important;
    img {
      width: 100%;
      height: 100%;
    }
  }
  .phone {
    cursor: pointer;
    position: relative;
    margin-top: -6px;
    width: 55px;
    /*height: 185px;*/
    height: 185px;
    /*overflow: hidden;*/
    background: #ffffff;
    border-radius: 50px;
    /*&:hover{*/
    /*    height: 185px;*/
    /*    transition: height 1s;*/
    /*}*/
    .mobile,
    .up {
      width: 55px;
      height: 65px;
    }
    .mobile {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 50px 50px 0 0;
      .phoneNumber {
        position: absolute;
        width: 185px;
        height: 65px;
        right: 60px;
      }
      &::after {
        content: "";
        width: 31px;
        height: 1px;
        background: #333;
        position: absolute;
        top: 65px;
      }
      img {
        width: 23px;
        height: 23px;
      }
    }
    .wechat {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 55px;
      height: 55px;
      position: relative;
      .ewm {
        width: 185px;
        height: 185px;
        position: absolute;
        right: 60px;
      }
      img {
        width: 25px;
        height: 21px;
      }
    }
    .up {
      border-radius: 0 0 50px 50px;
      background: #004c31;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 25px;
        height: 25px;
      }
    }
    /*img{*/
    /*    width: 50px !important;*/
    /*    height: 121px !important;*/
    /*}*/
  }
}
body,
div,
dl,
dt,
dd,
ul,
ol,
li,
h1,
h2,
h3,
h4,
h5,
h6,
pre,
form,
fieldset,
input,
textarea,
p,
blockquote,
th,
td {
  padding: 0;
  margin: 0;
}

a {
  text-decoration: none;
}

table {
  border-spacing: 0;
}

fieldset,
img {
  border: 0;
}

address,
caption,
cite,
code,
dfn,
em,
strong,
th,
var {
  font-weight: normal;
  font-style: normal;
}

strong {
  font-weight: bold;
}

ol,
ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

caption,
th {
  text-align: left;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-weight: normal;
  font-size: 100%;
  margin: 0;
  padding: 0;
}

q:before,
q:after {
  content: "";
}

abbr,
acronym {
  border: 0;
}

* {
  -webkit-box-sizing: border-box; /* Safari<=5 Android<=3 */
  -moz-box-sizing: border-box; /* <=28 */
  box-sizing: border-box;
}

/* Custom
   * --------------------------------------- */
body {
  font-family: 微软雅黑, MicrosoftYaHei;
}

.section {
  position: relative;
  text-align: center;
}

/* Menu
   * --------------------------------------- */
#menu-line {
  position: absolute;
  bottom: -4px;
  left: 0;
  width: 159px;
  height: 2px;
  background: #fff;
}

#menu {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 70;
  -webkit-font-smoothing: antialiased;
  -moz-font-smoothing: antialiased;
  letter-spacing: 1px;
  font-size: 1.1em;
}

#menu li {
  display: inline-block;
  margin: 10px 0px;
  position: relative;
}

#menu a {
  color: #fff;
  padding: 0 1.1em 1.1em 1.1em;
}

#menu li.active a:after {
  content: "";
  margin: 0 1.1em 0 1.1em;
  height: 2px;
  background: #fff;
  display: block;
  position: absolute;
  bottom: -6px;
  left: 0;
  right: 0;
  display: block;
}

/* Actions buttons
   * --------------------------------------- */
.actions {
  position: fixed;
  bottom: 2%;
  margin: 0 auto;
  z-index: 99;
  left: 0;
  right: 0;
  text-align: center;
}

.actions li {
  display: inline-block;
  margin: 0.3em 0.3em;
}

.actions-button {
  padding: 0.73em 1.47em;
  background: rgba(53, 73, 94, 0.47);
  border-radius: 5px;
  display: block;
  color: #fff;
  cursor: pointer;
}

/* Twitter
   * --------------------------------------- */
.twitter-share i {
  vertical-align: middle;
  position: relative;
  top: 2px;
  display: inline-block;
  width: 38px;
  height: 14px;
  color: white;
  top: -4px;
  left: -2px;
  fill: #fff;
}

.twitter-share svg {
  height: 40px;
  margin-top: -10px;
}

.view-github {
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: 999;
  padding: 0.93em 1.87em;
  background: #35495e;
  border-radius: 5px;
  display: block;
  color: #fff;
}
.modal {
  top: 0;
  left: 0;
  position: absolute;
  z-index: 2001;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  .mblock {
    background: rgba(0, 0, 0);
    width: 520px;
    min-height: 301px;
    border: 5px solid #ffa540;
    .abandon {
      margin: 45px 0 0 62px;
      width: 218px;
      height: 30px;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .age {
      margin-top: 32px;
      font-size: 12px;
      .ageVer {
        color: #ffa540;
      }
      .vap {
        margin: 0 auto;
        text-align: left;
        width: 85%;
        color: #ffffff;
      }
    }
    .slogan {
      font-size: 32px;
      font-family: FZChaoCuHei-M10;
      font-weight: 600;
      color: #ffffff;
      margin: 32px auto;
      span {
        font-size: 32px;
        text-align: left;
      }
    }
    .flex {
      display: flex;
      align-items: center;
      justify-content: space-around;
      margin-top: 32px;
      .leave {
        cursor: pointer;
        width: 165px;
        height: 42px;
        color: #ffffff;
        font-size: 16px;
        line-height: 42px;
        text-align: center;
        background: #242424;
        &:hover {
          background: #ffffff;
          color: #242424;
        }
      }
      .enter {
        cursor: pointer;
        margin-left: 17px;
        width: 165px;
        height: 42px;
        border: 2px solid #ffa540;
        font-size: 16px;
        line-height: 42px;
        text-align: center;
        color: #ffa540;
        &:hover {
          background: #ffa540;
          color: #242424;
        }
      }
    }
  }
}
@media screen and (max-width: 450px) {
  .xuanfu {
    position: fixed;
    right: 0;
    z-index: 12;
    top: 179 * 3px;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    .bear {
      width: 263 * 1.3px !important;
      height: 457 * 1.3px !important;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .phone {
      cursor: pointer;
      position: relative;
      margin-top: -6 * 2px;
      width: 55 * 2px;
      /*height: 185px;*/
      height: 185 * 2px;
      /*overflow: hidden;*/
      background: #ffffff;
      border-radius: 50px;
      /*&:hover{*/
      /*    height: 185px;*/
      /*    transition: height 1s;*/
      /*}*/
      .mobile,
      .up {
        width: 55 * 2px;
        height: 65 * 2px;
      }
      .mobile {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50px 50px 0 0;
        .phoneNumber {
          position: absolute;
          width: 185 * 2px;
          height: 65 * 2px;
          right: 60 * 2px;
        }
        &::after {
          content: "";
          width: 31 * 2px;
          height: 1px;
          background: #333;
          position: absolute;
          top: 65 * 2px;
        }
        img {
          width: 23 * 2px;
          height: 23 * 2px;
        }
      }
      .wechat {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 55 * 2px;
        height: 55 * 2px;
        position: relative;
        .ewm {
          width: 185 * 2px;
          height: 185 * 2px;
          position: absolute;
          right: 60 * 2px;
        }
        img {
          width: 25 * 2px;
          height: 21 * 2px;
        }
      }
      .up {
        border-radius: 0 0 50px 50px;
        background: #004c31;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 25 * 2px;
          height: 25 * 2px;
        }
      }
      /*img{*/
      /*    width: 50px !important;*/
      /*    height: 121px !important;*/
      /*}*/
    }
  }
}
</style>
